export default "__VITE_ASSET__Dr4Cb7CP__"